import debounce from 'lodash.debounce';
import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';

import TokenStore from '../stores/TokenStore';
import ProfileStore from '../stores/ProfileStore';
import CurrentOrganizationIdStore from '../stores/CurrentOrganizationIdStore';
import CurrentRoleStore from '../stores/CurrentRoleStore';
import JobAPI from '../util/JobAPI';

const JobActions = {
  loadAllJobs() {
    const jobsApi = new JobAPI(TokenStore.getToken()).jobs;

    let jobsPromise;
    if (CurrentRoleStore.isAdmin()) {
      // All org jobs (admin only)
      jobsPromise = jobsApi.allForOrg(CurrentOrganizationIdStore.getState());
    } else {
      // Only my jobs
      jobsPromise = jobsApi.all();
    }

    jobsPromise.then((jobs) => {
      AppDispatcher.dispatch({
        actionType: Constants.RECIEVE_RAW_JOBS,
        rawJobs: jobs,
      });
    }).catch((e) => {
      console.warn('Error Loading Jobs', e);
    });
  },

  // TODO: This is a hack until the api is fixed
  startPolling(jobId) {
    JobActions.refresh(jobId);
    JobActions.fetchLogs(jobId);
    const interval = setInterval(() => {
      JobActions.refresh(jobId);
      JobActions.fetchLogs(jobId);
    }, 10000);
    return () => { clearInterval(interval); };
  },

  refresh(jobId) {
    new JobAPI(TokenStore.getToken()).jobs.get(jobId).then((rawJob) => {
      if (rawJob && rawJob.id) {
        AppDispatcher.dispatch({
          actionType: Constants.RECIEVE_RAW_JOBS,
          rawJobs: [rawJob],
        });
      }
    });
  },

  fetchLogs(jobId) {
    new JobAPI(TokenStore.getToken()).jobs.getLogs(jobId).then((logs) => {
      AppDispatcher.dispatch({
        actionType: Constants.RECEIVE_JOB_LOGS,
        job: jobId,
        stdout: logs.stdout,
        stderr: logs.stderr,
      });
    }).catch((e) => {
      console.warn(`Error fetching logs for ${jobId}`, e);
    });
  },

  submitJob(name, organizationId, jobConfig) {
    const jobRequest = {
      ...jobConfig,
      name,
      organizationId: organizationId.toString(),
    };
    return new JobAPI(TokenStore.getToken()).jobs.create(jobRequest).then((response) => {
      AppDispatcher.dispatch({
        actionType: Constants.JOB_SUBMITTED,
        job: {
          id: response.id,
          config: jobRequest,
          submittedAt: Date.now(),
          creator: ProfileStore.getState().email,
        },
      });
      return response;
    });
  },

  getSavedJobsForCurrentOrganization() {
    this.getSavedJobs(CurrentOrganizationIdStore.getState());
  },

  getSavedJobs(organizationId) {
    new JobAPI(TokenStore.getToken()).jobs.getSavedJobs(organizationId).then((savedJobs) => {
      AppDispatcher.dispatch({
        actionType: Constants.SavedJobs.RECEIVE_SAVED_JOBS,
        savedJobs,
      });
    });
  },

  launchSavedJob(savedJobId) {
    new JobAPI(TokenStore.getToken()).jobs.launchSavedJob(savedJobId).then((jobId) => {
      AppDispatcher.dispatch({
        actionType: Constants.SavedJobs.SAVED_JOB_LAUNCHED,
        jobId,
      });
    });
  },

};

JobActions.debouncedLoadAllJobs = debounce(JobActions.loadAllJobs, 1000);

export default JobActions;
